import { postRequest } from 'utils/api/apiRequest'

export const activateValueCode = (value_code: string) => postRequest(`/value-codes/activate`, { value_code })
